module.exports = __webpack_public_path__ + "static/img/yinliang.e19cf92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/yinliang.png
// module id = 3+oD
// module chunks = 24